import { useQuery } from "@tanstack/react-query";
import { getSessions } from "services/Session.services";

import type { SessionsResponse } from "types/Session.type";

export default function useHomeDashboard() {
  // ===========================================================================
  // GET SESSIONS
  // ===========================================================================
  const {
    data: sessions,
    isLoading: isLoadingSessions,
    error: errorSessions,
  } = useQuery<SessionsResponse>({
    queryKey: ["sessions"],
    queryFn: getSessions,
  });

  return {
    sessions,
    isLoadingSessions,
    errorSessions,
  };
}
